import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';

/**
 * DeprecatedDashboardWrapper - Shows deprecation banner and redirects to new dashboard
 * REMOVAL DATE: January 3, 2025 (14 days from creation)
 * 
 * Usage tracking: Check console logs for "/dashboard-old accessed" entries
 */
export const DeprecatedDashboardWrapper = ({ children }) => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Log access for tracking
    console.warn('[DEPRECATION] /dashboard-old accessed at', new Date().toISOString());
    
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleRedirectNow = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Deprecation Banner */}
      <div className="bg-amber-500 text-white px-4 py-3 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-5 h-5" />
            <div>
              <span className="font-semibold">This dashboard is deprecated.</span>
              <span className="ml-2">Redirecting to the new dashboard in {countdown} seconds...</span>
            </div>
          </div>
          <button
            onClick={handleRedirectNow}
            className="flex items-center gap-2 bg-white text-amber-600 px-4 py-1.5 rounded-lg font-medium hover:bg-amber-50 transition-colors"
          >
            Go Now <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
      
      {/* Legacy Dashboard Content */}
      <div className="opacity-75 pointer-events-none">
        {children}
      </div>
    </div>
  );
};
